module.exports = ".captcha-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.captcha-element.error {\n  border-radius: 3px;\n  border: 1px solid red;\n  margin-right: 2px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/captcha/captcha.component.scss
// module id = ./src/app/shared/components/captcha/captcha.component.scss
// module chunks = main